import { createReducer, on } from "@ngrx/store";
import type { Nullable } from "@models";
import { IFuturesNewChallengeOptionConfiguration } from "../../futures/classes/FuturesNewChallengeOptionConfiguration";
import { setFuturesNewChallenge } from "./futures-new-challenge.actions";

export interface FuturesNewChallengeState {
  newChallenge: Nullable<IFuturesNewChallengeOptionConfiguration>;
}

const initialState: FuturesNewChallengeState = {
  newChallenge: null,
};

export const futuresNewChallengesReducer = createReducer(
  initialState,

  on(setFuturesNewChallenge, (state, { selectedChallenge }) => ({
    ...state,
    newChallenge: selectedChallenge,
  })),
);
